import React, { useContext, useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroller'
import { Button, LinearProgress, makeStyles, Modal } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import SearchIcon from '@material-ui/icons/Search'
import CloseIcon from '@material-ui/icons/Close'
import TableView from '../../components/TableView'
import DatePicker from '../../../../shared/DatePicker'

import TranslationLabel from '../../../../core/components/TranslationLabel'
import TextField from '@material-ui/core/TextField'
import { Typography } from '@material-ui/core'
import EmptyState from '../../components/EmptyState'
import { CoreContext } from '../../../../core/context/CoreContext'
import { BasketContext } from '../../../../core/context/BasketContext'
import { ProductsContext } from '../../context/ProductsContext'
import OpenOrdersModal from '../Products/OpenOrdersModal'
import ReservationsModal from '../Products/ReservationModal'
import PriceDtoHelper from '../../../../shared/PriceDtoHelper'

const useStyles = makeStyles((theme) => ({
  productsPageRoot: {
    flexGrow: 1,
    margin: 0,
    background: 'white',
  },
  stickyloader: {
    margin: 'auto',
    position: 'sticky',
    zIndex: 1,
    width: '100%',
    visibility: 'hidden',
  },
  loaderVisible: {
    visibility: 'visible',
  },
  stickyScrollButton: {
    'position': 'fixed',
    'top': 80,
    'left': '50%',
    'transform': 'translateX(-50%)',
    'zIndex': 100,
    'backgroundColor': 'white',
    '&:hover': {
      backgroundColor: 'white',
    },
  },
  buttons: {
    margin: 10,
  },
  seeProductsButton: {
    marginRight: 20,
  },
  inputField: {
    'margin': '10px 0px 10px 0px',
    '&::-webkit-search-decoration,::-webkit-search-cancel-button,::-webkit-search-results-button,::-webkit-search-results-decoration':
      {
        display: 'none',
      },
  },
  searchIcon: {
    fill: theme.palette.grey['700'],
    cursor: 'pointer',
  },
  modalWrapper: {
    backgroundColor: 'white',
    width: '500px',
    maxWidth: '100%',
    margin: 'auto',
    position: 'relative',
    top: '50%',
    transform: 'translateY(-50%)',
    padding: '25px',
    paddingTop: 10,
    textAlign: 'center',
    outline: 'none',
  },
  datePicker: {
    position: 'absolute',
    right: 15,
    width: 200,
    marginBottom: '15px',
    backgroundColor: 'white',
    borderRadius: 3,
  }
}))

export default function SearchPage() {
  const classes = useStyles()
  const core = useContext(CoreContext)
  const basketModel = useContext(BasketContext)
  const productsModel = useContext(ProductsContext)

  const [query, setQuery] = useState('')
  const [products, setProducts] = useState([])
  const [selectedProducts, setSelectedProducts] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [showSelected, setShowSelected] = useState(false)
  const [pageNumber, setPageNumber] = useState(1)
  const [hasMoreResults, setHasMoreResults] = useState(false)

  const [openOrdersModal, setOpenOrdersModal] = useState(undefined)
  const [reservationsModal, setReservationsModal] = useState(undefined)

  function handleQueryChange(e) {
    setQuery(e.target.value)
    setPageNumber(1)
  }

  const keypressHandler = (e) => {
    if (e.keyCode === 13) {
      //for the enter key
      search()
      setShowSelected(false)
    }
  }

  const showSelectedHandler = () => {
    setShowSelected(!showSelected)
    setPageNumber(1)
  }

  const clearSelectedProducts = () => {
    setSelectedProducts([])
  }

  const addSelectedProductsToBasket = () => {

    basketModel.multiAdd(
      selectedProducts.map((entry) => {

        const { campaignId, quantity, minimumQuantity } = entry;

        return {
          ...entry,
          qty: quantity,
          campaignId: PriceDtoHelper.findCampaignId(entry, quantity),
          requestedShippingDate: selectedDate,
        }
      }),
      () => {
        console.log('addSelectedProductsToBasket')
        clearSelectedProducts()

        // Create a new array by mapping over products to ensure re-render
        setProducts(
          products.map((prevProduct) => ({
            ...prevProduct,
            quantity: 0,
          })),
        )
      },
    )
  }

  const getMinDate = () => {
    const date = new Date()
    return new Date(date.setDate(date.getDate() + 1))
  }

  const addSingleProductToBasket = (product) => {

    basketModel.add({
      itemId: product.productNo,
      qty: product.quantity,
      campaignId: PriceDtoHelper.findCampaignId(product, product.quantity),
      requestedShippingDate: selectedDate,
    })

    setSelectedProducts(
      selectedProducts.filter((el) => el.productNo !== product.productNo),
    )
  }

  const onQuantityChange = (productNo, quantity) => {
    console.log('onQuantityChange' + quantity)
    const changingProductIndex = products.findIndex(
      (el) => el.productNo === productNo,
    )

    const changingSelectedProductIndex = selectedProducts.findIndex(
      (el) => el.productNo === productNo,
    )

    if (changingProductIndex + changingSelectedProductIndex === -2) {
      return console.log('changed quantity on product not in products lists')
    }

    if (changingSelectedProductIndex > -1) {
      let newSelectedProducts = [...selectedProducts]
      if (quantity == '0' || !quantity) {
        newSelectedProducts = newSelectedProducts.filter(
          (el) => el.productNo !== productNo,
        )
      } else {
        newSelectedProducts[changingSelectedProductIndex].quantity = quantity
      }

      setSelectedProducts(newSelectedProducts)
    } else if (changingProductIndex > -1 && quantity > 0) {
      const newSelectedProducts = [...selectedProducts]
      newSelectedProducts.push({ ...products[changingProductIndex], quantity })
      setSelectedProducts(newSelectedProducts)
    }
  }

  async function UpdateSelectedProducts() {
    console.log(selectedDate)

    const updatedEntries = await Promise.all(
      selectedProducts.map(async (item) => {
        const productDetails = await productsModel.getProductById(
          item.productNo,
          basketModel.basket.requestedShippingDate,
        )
        return { ...item, ...productDetails }
      }),
    )

    setSelectedProducts(updatedEntries)
  }

  async function UpdateProducts() {
    console.log(selectedDate)

    const updatedEntries = await Promise.all(
      products.map(async (item) => {
        const productDetails = await productsModel.getProductById(
          item.productNo,
          basketModel.basket.requestedShippingDate,
        )
        return { ...item, ...productDetails }
      }),
    )

    setProducts(updatedEntries)
  }

  const search = () => {
    setIsLoading(true)

    if (isLoading) {
      return
    }

    core.dataStore
    .searchProducts(options)
    .then((res) => {
      if (res && res.data) {
        setHasMoreResults(!res.data.isLastPage)
        if (pageNumber === 1) {
          setProducts(
            res.data.products.map((product) => {
              const alreadySelectedProduct = selectedProducts.find(
                (el) => el.productNo === product.productNo,
              )
              if (alreadySelectedProduct) {
                product.quantity = alreadySelectedProduct.quantity
              }
              return product
            }),
          )
        } else {
          setProducts(
            products.concat(
              res.data.products.map((product) => {
                const alreadySelectedProduct = selectedProducts.find(
                  (el) => el.productNo === product.productNo,
                )
                if (alreadySelectedProduct) {
                  product.quantity = alreadySelectedProduct.quantity
                }
                return product
              }),
            ),
          )
        }

        setPageNumber(pageNumber + 1)
      }
    })
    .catch(console.log)
    .finally(() => {
      setIsLoading(false)
    })
}

  const currentDateValue = () => {
    if (basketModel.basket.requestedShippingDate) {
      const basketDate  = new Date(basketModel.basket.requestedShippingDate)

      const formattedbasketDate = `${basketDate.getFullYear()}-${String(
        basketDate.getMonth() + 1,
      ).padStart(2, '0')}-${String(basketDate.getDate()).padStart(2, '0')}T00:00:00`
      return formattedbasketDate;
    }

    const date = new Date()
    do {
      date.setDate(date.getDate() + 1); // Move to the next day
    } while (date.getDay() === 0 || date.getDay() === 6); // Check if it's Sunday (0) or Saturday (6)

    const formattedDate = `${date.getFullYear()}-${String(
      date.getMonth() + 1,
    ).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}T00:00:00`
    return formattedDate;
  }

  const [selectedDate, setSelectedDate] = useState(currentDateValue())

  const setDate = (x) => {
    const date = new Date(x.setHours(12, 0, 0, 0))
    const formattedDate = `${date.getFullYear()}-${String(
      date.getMonth() + 1,
    ).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}T00:00:00`

    basketModel.basket.requestedShippingDate = formattedDate
    setSelectedDate(formattedDate)
    UpdateSelectedProducts()
    UpdateProducts()
  }

  const options = {
    userId: core.user.userId,
    customerId: core.user.selectedCustomer.accountNo,
    selectedFacetValues: {
      brand: [],
      mainColor: [],
      subCategory: [],
      category: [],
      news: [],
    },
    languageCode: core.user.languageCode,
    pageSize: 24,
    pageNumber,
    query: query,
    sortByField: 'BrandId',
    descendingSortOrder: false,
    requestedShippingDate: selectedDate,
  }

  //console.log('selectedProducts:', JSON.stringify(selectedProducts));
  //console.log('products:', JSON.stringify(products));

  return (
    <div className={classes.productsPageRoot}>
      <OpenOrdersModal
        openOrdersProduct={products?.find((el) => el && el.productNo == openOrdersModal,)}
        setOpenOrdersModal={setOpenOrdersModal}
      />
      <ReservationsModal
        reservationsProduct={products?.find((el) => el && el.productNo == reservationsModal,)}
        setReservationsModal={setReservationsModal}
      />
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
        <Typography
          variant='h4'
          component='h1'>
          <TranslationLabel name='searchPage' />
        </Typography>
        <DatePicker
          autoOk
          size='small'
          disablePast
          variant='inline'
          inputVariant='outlined'
          label={<TranslationLabel name='chooseShippingDate' />}
          minDate={getMinDate()}
          onChange={(e) => setDate(e)}
          disabled={basketModel.basket.entries.find(
            (x) => x.campaignId != null,
          )}
          value={selectedDate}
        />
      </div>
      <div style={{ float: 'right' }}>
        <Button
          onClick={showSelectedHandler}
          className={`${classes.seeProductsButton} ${classes.buttons}`}
          variant='contained'
          color='primary'>
          <TranslationLabel
            name={showSelected ? 'backToSearch' : 'seeSelectedProducts'}
          />
        </Button>
        <Button
          onClick={addSelectedProductsToBasket}
          className={classes.buttons}
          startIcon={<AddIcon />}
          variant='contained'
          color='primary'>
          <span>
            <TranslationLabel name='add' /> {selectedProducts.length}{' '}
            <TranslationLabel name='productsToBasket' />
          </span>
        </Button>
      </div>
      <TextField
        onKeyDown={keypressHandler}
        fullWidth
        label={<TranslationLabel name='searchPageInputLabel' />}
        id='filled-margin-dense'
        type='search'
        variant='outlined'
        value={query}
        onChange={handleQueryChange}
        className={classes.inputField}
        InputProps={{
          startAdornment: <SearchIcon className={classes.searchIcon} />,
          endAdornment: (
            <CloseIcon
              onClick={() => setQuery('')}
              className={classes.searchIcon}
            />
          ),
        }}
      />
      <LinearProgress
        className={`${classes.stickyloader} ${
          isLoading && classes.loaderVisible
        }`}></LinearProgress>

      {/* Product list */}
      <div style={{ marginTop: '50px' }}>
        <InfiniteScroll
          loadMore={search}
          hasMore={hasMoreResults}>
          <TableView
            hideHeader={true}
            EmptyStartQuantity={true}
            ShowSelected={showSelected}
            addToBasket={addSingleProductToBasket}
            onQuantityChange={onQuantityChange}
            products={showSelected ? selectedProducts : products}
            setOpenOrdersModal={setOpenOrdersModal}
            setReservationsModal={setReservationsModal}
          />
        </InfiniteScroll>
      </div>

      {/* No products */}
      {!isLoading && products.length === 0 && query && (
        <EmptyState
          main='productSearchEmptyMain'
          sub='productSearchEmptySub'
        />
      )}
    </div>
  )
}
